import { render, staticRenderFns } from "./textArea.vue?vue&type=template&id=3e99d5ec&scoped=true"
import script from "./textArea.vue?vue&type=script&lang=js"
export * from "./textArea.vue?vue&type=script&lang=js"
import style0 from "./textArea.vue?vue&type=style&index=0&id=3e99d5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e99d5ec",
  null
  
)

export default component.exports